import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient, { axiosWithAuth } from '@/services/axios';

export const fetchWheelData = createAsyncThunk(
  'spinTheWheel/fetchWheelData',
  async (_, { getState, rejectWithValue }) => {
    try {
      const url = `/api/available-spin-wheel-offers`;

      const result = await axiosClient.get(url);
      return result.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchSpinningResult = createAsyncThunk(
  'spinTheWheel/fetchSpinningResult',
  async (_, { getState, rejectWithValue }) => {
    const { accessToken } = getState().auth;

    if (!accessToken) {
      return;
    }

    try {
      const url = `/api/spin-wheel-result`;

      const result = await axiosWithAuth(accessToken).post(url);

      return result.data.data;
    } catch (error) {
      console.log({ error });

      return rejectWithValue(error.response);
    }
  },
);
